import React from 'react';

import Mpseriesphone from './Mpseriesphone';
import Mpseriesapplicati from './Mpseriesapplicati';
import Increased from './Increased';
import MPseriesplaten from './MPseriesplaten';



const Mpseriesp = () => {
    return (
        <div>
              <Mpseriesphone />
            <Mpseriesapplicati />
            <Increased />
            <MPseriesplaten />

        </div>
    );
};

export default Mpseriesp;
